import React from 'react';
import styles from './ActionButtonView.module.scss';
import { getIcon } from '../../../../assets/icons';

export interface ActionButtonViewProps {
  onClick: () => void;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  variant?: 'primary' | 'secondary' | 'tercery';
  label?: string;
}

export default function ActionButtonView({
  onClick,
  disabled = false,
  size = 'medium',
  variant = 'primary',
  label
}: ActionButtonViewProps) {
  const handleClick = () => {
    if (!disabled) {
      onClick();
    }
  };

  const getSizeClass = () => {
    switch (size) {
      case 'small':
        return styles.actionButtonSmall;
      case 'large':
        return styles.actionButtonLarge;
      default:
        return styles.actionButtonMedium;
    }
  };

  const getVariantClass = () => {
    switch (variant) {
      case 'secondary':
        return styles.actionButtonSecondary;
      case 'tercery':
        return styles.actionButtonTercery;
      default:
        return styles.actionButtonPrimary;
    }
  };

  return (
    <button
      className={[
        styles.actionButton,
        getSizeClass(),
        getVariantClass(),
        disabled && styles.actionButtonDisabled
      ].join(' ')}
      onClick={handleClick}
      disabled={disabled}
      title={label || 'Actions'}
    >
      <div className={styles.iconContainer}>
        {getIcon('gear', { 
          size: size === 'small' ? 16 : size === 'large' ? 24 : 20,
          color: variant === 'primary' ? '#fff' : '#374151'
        })}
      </div>
      {label && (
        <span className={styles.label}>{label}</span>
      )}
    </button>
  );
}
